const resultsPage = 'results';
const detailsPage = 'details';
const tripDetailsPage = 'tripdetails';
const myTripsPage = 'mytrips';
const pagesWithOf2Login = [resultsPage, detailsPage, tripDetailsPage, myTripsPage];
const getCurrentPage = () => Odigeo.History.getPageNameFromFragment().split('/')[0];
const isPageWithOf2Login = () => pagesWithOf2Login.includes(getCurrentPage());

module.exports = {
    getCurrentPage,
    isPageWithOf2Login,
};
